export default ['bmw', 'mini', 'vw']
